import { render, staticRenderFns } from "./SaleActivityDetail.vue?vue&type=template&id=42511cdf&scoped=true"
import script from "./SaleActivityDetail.vue?vue&type=script&lang=js"
export * from "./SaleActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./SaleActivityDetail.vue?vue&type=style&index=0&id=42511cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42511cdf",
  null
  
)

export default component.exports